"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRepositoryEvents = void 0;
const repository_events_1 = require("@sensenet/repository-events");
const react_1 = require("react");
const use_repository_1 = require("./use-repository");
/**
 * Returns an EventHub instance of the current Repository
 * Works inside RepositoryContext.
 */
const useRepositoryEvents = () => {
    const repo = use_repository_1.useRepository();
    const [eventHub, setEventHub] = react_1.useState(new repository_events_1.EventHub(repo));
    react_1.useEffect(() => {
        const eh = new repository_events_1.EventHub(repo);
        setEventHub(eh);
        return () => eh.dispose();
    }, [repo]);
    return eventHub;
};
exports.useRepositoryEvents = useRepositoryEvents;
//# sourceMappingURL=use-repository-events.js.map